import React from 'react';
import { connect, useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { createUseStyles } from 'react-jss';
import { useTranslation } from 'react-i18next';
import { getOnboardingState } from '../../../store/selectors';
import InformationIcon from '../../utility/InformationIcon';
import SunIcon from '../../utility/SunIcon.jsx';
import { fireGTM } from '../../../gtm/gtmUtil';
import { degreePairingPage_GTM } from '../../../gtm/datalayers/degreePairingDataLayers.json';
import { modalOpen_GTM } from '../../../gtm/datalayers/utilDataLayers.json';

function BuildCareerButton(props) {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const useStyles = createUseStyles({
    buildCareerPathButton: {
      backgroundColor: props.tenant.primary,

      '&:hover': {
        border: `2px solid ${props.tenant.primary}`,
        color: `${props.tenant.primary}`,
      },
    },
  });

  const classes = useStyles(props);

  const buttonColoring = {
    background: `${props.tenant.primary}`,
  };

  const handleBuildCareerSelected = () => {
    degreePairingPage_GTM.buildCareer.section = props.career.titleEn;
    fireGTM(degreePairingPage_GTM.buildCareer);
    dispatch({
      type: 'SET_CAREER_TAB',
      payload: {
        careerInfo: {
          ...props.onboarding.degreeChoices,
        },
        careerTabSelected: true,
        currentTab: props.careerProps.tabNumber,
      },
    });
  };

  const displayButtonText = () => {
    return props.shortenButtonText
      ? t('Build path')
      : t('Build your career path');
  };

  const handleInfoButtonSelected = () => {
    props.history.push(
      `${props.location.pathname}?career=${encodeURIComponent(
        props.career.titleEn
      )}`
    );
  };

  return (
    <div className="build-button-info-icon-container">
      {props.careerProps.classActive === 'inactive' ? (
        <button
          className={`button--primary primary-filled ${props.overRideStyle}-inactive ${classes.buildCareerPathButton}`}
          onClick={() => handleBuildCareerSelected()}
          type="button"
          data-cy="build-path-button"
          onKeyDown={(e) => {
            if (['Enter'].includes(e.key)) handleBuildCareerSelected();
          }}
          style={buttonColoring}
          aria-label={`${
            props.shortenButtonText ? 'Build path' : 'Build your career path'
          } below with available degrees for career of ${props.career.titleEn}`}
        >
          {displayButtonText()}
        </button>
      ) : (
        <button
          className={`button--primary ${props.overRideStyle}`}
          onClick={() => handleBuildCareerSelected()}
          type="button"
          data-cy="build-path-button"
        >
          {displayButtonText()}
        </button>
      )}
      <div className="outlook-info-icon">
        {props.career.careerOutlook ? (
          <SunIcon
            setParentOnClick={props.setBrightOutlookModal}
            additionalClassName="build-career"
          />
        ) : null}
        <button
          tabIndex="-1"
          type="button"
          className="info-button"
          data-cy="info-button"
          id={`info-${props.career.titleEn}`}
          aria-label={`open info modal for - ${props.career.titleEn}`}
          onClick={() => {
            handleInfoButtonSelected();
          }}
          onKeyDown={(e) => {
            if (['Enter'].includes(e.key)) handleInfoButtonSelected();
          }}
        >
          <InformationIcon
            color={props.tenant.primary}
            gtmObj={modalOpen_GTM}
            text="information"
            section={props.career.titleEn}
            modalImage={props.modalImage}
          />
        </button>
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  const onboarding = getOnboardingState(state);

  return { onboarding };
}

export default withRouter(connect(mapStateToProps)(BuildCareerButton));
